import { Component, Input, OnInit } from '@angular/core';

import { MEDIA_ENGINE_CONSTANTS } from '@finder/shared/constants/app.constants';
import { GenericText } from '../generic-text/generic-text.interface';
import { CaptionedMediaGallery, ConfigCaptionedMediaGallery } from './captioned-media-gallery.interface';
import { CommonModule } from '@angular/common';
import { MediaGalleryComponent } from '../media-gallery/media-gallery.component';
import { GenericTextComponent } from '../generic-text/generic-text.component';
import { HasTextPipe } from '@finder/shared/utils/pipes/has-text/has-text.pipe';
import { IsMeMediaPipe } from '@finder/shared/utils/pipes/is-me-media/is-me-media.pipe';

@Component({
    selector: 'finder-captioned-media-gallery',
    templateUrl: './captioned-media-gallery.component.html',
    styleUrls: ['./captioned-media-gallery.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MediaGalleryComponent,
        GenericTextComponent,
        HasTextPipe, // hasText
        IsMeMediaPipe, // isMeMedia
    ]
})
export class CaptionedMediaGalleryComponent implements OnInit {
    @Input() data: CaptionedMediaGallery;
    protected config: ConfigCaptionedMediaGallery;
    protected mediaCaption: GenericText;
    protected theme: string;

    constructor() {}

    ngOnInit(): void {
        this.config = this.data?.config ?? {};
        this.theme = this.data?.theme ?? MEDIA_ENGINE_CONSTANTS.defaultTheme;
        this.config.callbacks = this.overrideCallbacks();
    }

    private overrideCallbacks(): any {
        return {
            onSlideLoad: (slideData: any) => {
                if (!slideData?.caption) {
                    return;
                }
                this.mediaCaption = slideData.caption;
            },
        };
    }
}
